module.exports = __webpack_public_path__ + "static/media/unfriendly-fire.8437b1a2.svg";